export interface Category {
  id: string;
  name: string;
  nameFr: string;
  description: string;
  url: string;
  icon: string;
  image: string;
}

export const categories: Category[] = [
  {
    id: 'shoes',
    name: 'Shoes',
    nameFr: 'Chaussures',
    description: 'Sneakers, bottes et plus',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-footprint-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20casual%20sneakers%20in%20soft%20grey%20and%20cream%20colorway%20on%20clean%20studio%20background%20warm%20natural%20light%20Scandinavian%20aesthetic%20product%20photography%20high%20detail%20simple%20composition&width=600&height=400&seq=cat-shoes-v2-b&orientation=landscape',
  },
  {
    id: 'hoodies',
    name: 'Hoodies/Sweaters',
    nameFr: 'Hoodies & Sweats',
    description: 'Confort et style urbain',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    icon: 'ri-t-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20oversized%20oatmeal%20beige%20hooded%20sweatshirt%20on%20clean%20cream%20background%20soft%20natural%20light%20Scandinavian%20product%20photography%20warm%20tones%20simple%20composition&width=600&height=400&seq=cat-hoodies-v2-b&orientation=landscape',
  },
  {
    id: 'tshirts',
    name: 'T-Shirts',
    nameFr: 'T-Shirts',
    description: 'Basiques et éditions limitées',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20white%20cotton%20tshirt%20neatly%20folded%20on%20clean%20neutral%20background%20soft%20studio%20lighting%20Scandinavian%20aesthetic%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-tshirts-v2-b&orientation=landscape',
  },
  {
    id: 'jackets',
    name: 'Jackets',
    nameFr: 'Vestes',
    description: 'Vestes et manteaux tendance',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    icon: 'ri-shirt-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20olive%20green%20lightweight%20jacket%20on%20clean%20cream%20background%20natural%20light%20Scandinavian%20style%20product%20photography%20warm%20tones%20simple%20composition&width=600&height=400&seq=cat-jackets-v2-b&orientation=landscape',
  },
  {
    id: 'pants',
    name: 'Pants/Shorts',
    nameFr: 'Pantalons & Shorts',
    description: 'Du casual au tailoring',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    icon: 'ri-walk-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20tailored%20beige%20trousers%20on%20clean%20studio%20background%20soft%20warm%20lighting%20Scandinavian%20aesthetic%20product%20photography%20simple%20clean%20composition&width=600&height=400&seq=cat-pants-v2-b&orientation=landscape',
  },
  {
    id: 'headwear',
    name: 'Headwear',
    nameFr: 'Couvre-chefs',
    description: 'Casquettes, bonnets & Co.',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    icon: 'ri-glasses-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20cream%20baseball%20cap%20on%20clean%20background%20soft%20natural%20light%20Scandinavian%20aesthetic%20product%20photography%20warm%20tones%20simple%20composition&width=600&height=400&seq=cat-headwear-v2-b&orientation=landscape',
  },
  {
    id: 'sets',
    name: 'Sets',
    nameFr: 'Ensembles',
    description: 'Coordonnés assortis',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    icon: 'ri-group-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20matching%20top%20and%20bottom%20set%20in%20soft%20pastel%20tones%20on%20clean%20studio%20background%20warm%20light%20Scandinavian%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-sets-v2-b&orientation=landscape',
  },
  {
    id: 'underwear',
    name: 'Underwear/Underpants',
    nameFr: 'Sous-vêtements',
    description: 'Essentiels du quotidien',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    icon: 'ri-user-heart-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20soft%20cotton%20underwear%20basics%20on%20clean%20cream%20background%20natural%20light%20subtle%20Scandinavian%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-underwear-v2-b&orientation=landscape',
  },
  {
    id: 'jersey',
    name: 'Jersey',
    nameFr: 'Maillots',
    description: 'Sport et lifestyle',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    icon: 'ri-basketball-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20athletic%20jersey%20in%20warm%20terracotta%20tone%20on%20clean%20studio%20background%20soft%20light%20Scandinavian%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-jersey-v2-b&orientation=landscape',
  },
  {
    id: 'accessories',
    name: 'Accessories',
    nameFr: 'Accessoires',
    description: 'Détails qui font la différence',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    icon: 'ri-handbag-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20gold%20toned%20jewelry%20and%20accessories%20on%20clean%20cream%20marble%20surface%20warm%20natural%20light%20Scandinavian%20aesthetic%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-accessories-v2-b&orientation=landscape',
  },
  {
    id: 'bags',
    name: 'Bags',
    nameFr: 'Sacs',
    description: 'Sacs à main & bagagerie',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    icon: 'ri-shopping-bag-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20structured%20tote%20bag%20in%20warm%20cognac%20leather%20on%20clean%20cream%20background%20soft%20light%20Scandinavian%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-bags-v2-b&orientation=landscape',
  },
  {
    id: 'belts',
    name: 'Belts',
    nameFr: 'Ceintures',
    description: 'Accessoires indispensables',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    icon: 'ri-links-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20genuine%20leather%20belt%20in%20rich%20brown%20tone%20on%20clean%20studio%20background%20warm%20natural%20light%20Scandinavian%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-belts-v2-b&orientation=landscape',
  },
  {
    id: 'perfumes',
    name: 'Perfumes',
    nameFr: 'Parfums',
    description: 'Fragrances exclusives',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    icon: 'ri-contrast-drop-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20glass%20perfume%20bottle%20with%20warm%20amber%20fragrance%20on%20clean%20cream%20background%20soft%20light%20Scandinavian%20aesthetic%20product%20photography%20simple%20composition&width=600&height=400&seq=cat-perfumes-v2-b&orientation=landscape',
  },
  {
    id: 'otherstuff',
    name: 'OtherStuff',
    nameFr: 'Autres Articles',
    description: 'Découvrez nos autres trouvailles',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    icon: 'ri-store-2-line',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20lifestyle%20accessories%20collection%20with%20sunglasses%20watch%20and%20small%20leather%20goods%20on%20clean%20cream%20background%20warm%20light%20Scandinavian%20photography%20simple%20composition&width=600&height=400&seq=cat-otherstuff-v2-b&orientation=landscape',
  },
];

export const categoryQuickLinks = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html' },
  { name: 'Hoodies/Sweaters', url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/category-913-T-Shirts.html' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/category-914-Jackets.html' },
  { name: 'Pants/Shorts', url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/category-916-Headwear.html' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/category-917-Sets.html' },
  { name: 'Underwear/Underpants', url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/category-919-Jersey.html' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/category-920-Accessories.html' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/category-921-Bags.html' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Bags.html' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Bags.html' },
  { name: 'OtherStuff', url: 'https://kaspreadsheet.com/search-924/name/Bags.html' },
];